export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-1.796 1.99L19 21H5l-.204-.01a2 2 0 0 1-1.785-1.786L3 19V5a2 2 0 0 1 2-2h14ZM5 4.5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5Zm6 13.623H6v-3h5v3Zm7 0h-5v-3h5v3Zm-7-4.17H6v-3h5v3Zm7 0h-5v-3h5v3ZM18 9.5H6v-3h12v3Z"/>
</svg>
`;
